import { Text } from '@mnd-frontend/ui';

const WhoReceivesContent = () => (
  <>
    <Text as="h3" variant="headlineSmall">
      Who receives my content?
    </Text>
    <Text as="h4" variant="labelMedium" marginTop="SPACING_3">
      Subscribers
    </Text>
    <Text as="p" variant="body">
      A subscriber is an individual who created a Mynewsdesk account to subscribe to stories.
      Subscribers can set up alerts for specific keywords, topics or regions. Subscribers might not
      know about your brand specifically, but will receive your story if it matches their alert
      criteria.
    </Text>
    <Text as="h4" variant="labelMedium" marginTop="SPACING_3">
      Followers
    </Text>
    <Text as="p" variant="body">
      A follower is an individual who follows your newsroom and automatically receives every story
      that you publish.
    </Text>
    <Text as="h4" variant="labelMedium" marginTop="SPACING_3">
      Contacts
    </Text>
    <Text as="p" variant="body">
      A contact is an individual added to your account through Contacts, either manually or through
      an import. You can segment your contacts using contact lists. Contacts receive every story
      where they are listed as a recipient.
    </Text>
  </>
);

export default WhoReceivesContent;
